module.exports = __webpack_public_path__ + "static/media/c_kan_img.5771b39c.jpg";